import { StyleSheet } from "../../../../styles/theme";
export default StyleSheet.create({
  checkboxWrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
});